import API from "../context/API";

export const passwordResetAPI = {
  // Request password reset for merchant
  requestPasswordReset: async (email) => {
    try {
      const response = await API.post("/merchant/forgot-password", { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Validate reset token
  validateResetToken: async (token) => {
    try {
      const response = await API.post("/merchant/validate-reset-token", { token });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Reset password with new password
  resetPassword: async (token, newPassword) => {
    try {
      const response = await API.post("/merchant/reset-password", {
        token,
        new_password: newPassword
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
